import { mapValues } from 'lodash';
/**
 * Version 15 migrations agenda widget
 * - add Limit Session Visibility by Registration Type display toggle option
 */
export default function v15(website) {
  return {
    ...website,
    eventVersion: 15,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'Agenda' && !layoutItem.config.display.limitByRegistrationType) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            display: {
              ...layoutItem.config.display,
              limitByRegistrationType: false
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
